import { render, staticRenderFns } from "./CardDetails.vue?vue&type=template&id=1df6bda8&scoped=true"
import script from "./CardDetails.vue?vue&type=script&lang=ts"
export * from "./CardDetails.vue?vue&type=script&lang=ts"
import style0 from "./CardDetails.vue?vue&type=style&index=0&id=1df6bda8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6bda8",
  null
  
)

export default component.exports